import getRequest from '../../../getRequest';

/**
 * Get all users from PRISM db.
 *
 * @returns {object}
 */
const getAllGroups = () => {
  const endpoint = '/users-management/get-all-user-group/';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get All Groups')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default getAllGroups;
